<pos-app-spinner [show]="isLoading$ | async"></pos-app-spinner>
<form *ngIf="orderHeader" [formGroup]="form">
  <mat-tab-group class="order-header-tab" selectedIndex="0" [mat-stretch-tabs]="false">
    <mat-tab label="ORDER HEADER">
      <div class="py-2">
        <div class="row row-gap mx-0">
          <div class="col-3 d-flex align-items-center">
            <label class="d-flex align-items-center col-5">
              CUSTOMER
              <span *ngIf="orderHeader?.orderNumber.startsWith('T')" class="my-auto pl-2">
                <mat-icon
                  *ngIf="
                    (!isExternalUser && !isProgrammeUser) ||
                    ((isExternalUser || isProgrammeUser) && form.controls.orderType.value === 'SQ' && !isGenericQuotesOnlyTF)
                  "
                  (click)="selectNewCustomer()"
                  title="Change Customer"
                  >edit</mat-icon
                >
              </span>
            </label>
            <div class="col-7 nowrap">
              <input
                class="form-control overflow-hidden text-truncate underline"
                [readonly]="
                  (isExternalUser || isProgrammeUser) &&
                  (form.controls.orderType.value !== 'SQ' || (form.controls.orderType.value === 'SQ' && isGenericQuotesOnlyTF)) || (selectedCustomer?.readOnlyCustomerYN === 'Y') 
                "
                (click)="editCustomer()"
                [value]="form.controls.customerName.value"
              >
             
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">DISPATCH FROM</label>
            <div class="col-7">
              <div class="row">
                <div [ngClass]="isShowUser && orderHeader?.orderNumber.startsWith('T') ? 'col-10' : 'col-12'">
                  <div *ngIf="!showNonCorpStoreList; else nonCorpOrder" class="w-100 my-auto">
                    <ng-select
                      *ngIf="!isProgrammeUser && !isExternalUser"
                      formControlName="branch"
                      [appendTo]="'body'"
                      [clearable]="false"
                      class="custom"
                      [ngClass]="{
                        'border border-danger rounded': form.controls.branch.errors
                      }"
                    >
                      <ng-option *ngFor="let branch of branchList" [value]="branch.BranchCode">
                        {{ branch.BranchDescription }} ({{ branch.BranchCode }})
                      </ng-option>
                      <ng-template ng-label-tmp let-item="item">
                        {{ item | branch: branchList }}
                      </ng-template>
                    </ng-select>
                    <ng-select
                      *ngIf="isProgrammeUser || isExternalUser"
                      formControlName="branch"
                      [appendTo]="'body'"
                      [clearable]="false"
                      class="custom"
                      [readonly]="orderHeader?.readOnlyYN === 'Y'"
                    >
                      <ng-option *ngFor="let allAllowed of allAllowedBranchesList" [value]="allAllowed.BranchCode">
                        {{ allAllowed.BranchDescription }} ({{ allAllowed.BranchCode }})
                      </ng-option>
                    </ng-select>
                  </div>
                  <ng-template #nonCorpOrder>
                    <div
                      class="w-100 my-auto"
                      [ngClass]="{
                        'border border-danger rounded': form.controls.branch.errors
                      }"
                      *ngIf="
                        (!isExternalUser && !isProgrammeUser) ||
                        ((isProgrammeUser || isExternalUser) &&
                          orderHeader?.orderType !== 'ZZ' &&
                          orderHeader?.orderType !== 'SF' &&
                          showNonCorpStoreList)
                      "
                    >
                      <ng-select
                        *ngIf="orderHeader?.readOnlyYN === 'N'"
                        formControlName="branch"
                        [appendTo]="'body'"
                        [clearable]="false"
                        class="custom"
                        [readonly]="(isProgrammeUser || isExternalUser) && orderHeader?.orderType !== 'ZZ' && orderHeader?.orderType !== 'SF'"
                      >
                        <ng-option *ngFor="let store of nonCorpStoreList" [value]="store.customerNumber">
                          {{ store.customerName }}
                          <ng-container *ngIf="store.address1"
                            >({{ store.address1 }}, {{ store.suburb }}, {{ store.postCode }}, {{ store.state }})</ng-container
                          >
                        </ng-option>
                      </ng-select>
                      <div *ngIf="orderHeader?.readOnlyYN === 'Y'" class="form-control overflow-hidden text-truncate">
                        {{ orderHeader.shipToName }}
                      </div>
                    </div>
                    <div
                      class="w-100 my-auto"
                      [ngClass]="{
                        'border border-danger rounded': form.controls.branch.errors
                      }"
                      *ngIf="(isProgrammeUser || isExternalUser) && (orderHeader?.orderType === 'ZZ' || orderHeader?.orderType === 'SF')"
                    >
                      <ng-select
                        formControlName="branch"
                        [appendTo]="'body'"
                        [clearable]="false"
                        class="custom"
                        [readonly]="orderHeader?.readOnlyYN === 'Y'"
                      >
                        <ng-option *ngFor="let allAllowed of allAllowedBranchesList" [value]="allAllowed.BranchCode">
                          {{ allAllowed.BranchDescription }} ({{ allAllowed.BranchCode }})
                        </ng-option>
                      </ng-select>
                    </div>
                  </ng-template>
                </div>
                <span class="my-auto" *ngIf="isShowUser && orderHeader?.quickSaleYN !== 'Y' && orderHeader?.orderNumber.startsWith('T')">
                  <mat-icon [title]="showNonCorpStoreList ? 'Switch to ARB branch' : 'Switch to Non-Corp store'" (click)="switchShowOrder()">
                    compare_arrows
                  </mat-icon>
                </span>
              </div>
            </div>
          </div>

          <div class="col-3 d-flex align-items-center">
            <label class="col-5">ORDER TYPE</label>
            <div class="col-7" *ngIf="orderHeader?.readOnlyYN === 'N'">
              <ng-select
                formControlName="orderType"
                [appendTo]="'body'"
                [clearable]="false"
                [ngClass]="{
                  'border border-danger rounded': form.controls.orderType.errors
                }"
                [readonly]="
                  orderHeader?.readOnlyYN === 'Y' ||
                  ((isExternalUser || isProgrammeUser) && (orderHeader?.orderType === 'ZZ' || orderHeader?.orderType === 'SF'))
                "
              >
                <ng-option *ngFor="let orderType of orderTypes" [value]="orderType.OrderTypeCode"> {{ orderType.OrderTypeDescription }} </ng-option>
              </ng-select>
            </div>
            <div class="col-6">
              <input
                *ngIf="orderHeader?.readOnlyYN === 'Y'"
                class="form-control text-uppercase"
                value="{{ getOrderTypeDescription(orderHeader?.orderType) }}"
                readonly="true"
              />
            </div>
          </div>

          <div class="col-3 d-flex align-items-center" *ngIf="!isCreditOrder && latestATPDate">
            <label class="col-5">ATP</label>
            <div class="col-7">
              <div class="input-group">
                <input class="form-control" value="{{ latestATPDate }}" [readonly]="true" />
              </div>
            </div>
          </div>

          <div class="col-3 d-flex align-items-center" *ngIf="!latestATPDate">
            <label class="col-5"></label>
            <div class="col-7">
              <div class="input-group"></div>
            </div>
          </div>

          <div class="col-3 d-flex align-items-center">
            <label class="col-5">REFERENCE <span *ngIf="isOrderReferenceRequired" style="color: red">*</span></label>
            <div class="col-7">
              <input
                id="referenceInput"
                class="form-control"
                formControlName="reference"
                maxlength="25"
                [class.is-invalid]="isOrderReferenceRequired"
                [readonly]="orderHeader?.readOnlyYN === 'Y'"
              />
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">ORDER NO</label>
            <div class="col-7">
              <input class="form-control" formControlName="orderNumber" [readonly]="orderHeader?.readOnlyYN === 'Y'" />
            </div>
          </div>

          <div class="col-3 d-flex align-items-center" *ngIf="isCreditOrder">
            <label class="col-5">REASON *</label>
            <div class="col-7">
              <ng-select
                [placeholder]="'Select reason for credit'"
                [appendTo]="'body'"
                [class.is-invalid]="!form.controls.creditReason.value"
                formControlName="creditReason"
                [readonly]="orderHeader?.readOnlyYN === 'Y'"
              >
                <ng-option *ngFor="let reason of creditReasonList" [value]="reason.code"> {{ reason.description }} ({{ reason.code }}) </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center" *ngIf="isProgrammeUser">
            <label class="col-5">FIT LOCATION</label>
            <div class="col-7">
              <ng-select
                [readonly]="orderHeader?.readOnlyYN === 'Y'"
                formControlName="fitLocation"
                [appendTo]="'body'"
                [clearable]="false"
                [ngClass]="{
                  'border border-danger rounded': form.controls.orderType.errors
                }"
                placeholder="Select"
              >
                <ng-option *ngFor="let fitLocation of listFitLocations" [value]="fitLocation.fitLocationCode">
                  {{ fitLocation.fitLocationDescription }}
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center" *ngIf="!isProgrammeUser && !isCreditOrder">
            <label class="col-5"></label>
            <div class="col-7"></div>
          </div>

          <div class="col-3 d-flex align-items-center">
            <label class="col-5" *ngIf="orderHeader?.workshopBookingTF !== true">REQUEST DATE</label>
            <label class="col-5" *ngIf="orderHeader?.workshopBookingTF === true">
              FITTING DATE {{ orderHeader?.fitDateArray.length > 1 ? '(' + getFitDaysCount() + ' days)' : '' }}</label
            >
            <div class="col-7">
              <div class="input-group">
                <div *ngIf="checkOrderHeaderMessages() && orderHeader?.workshopBookingTF === true" class="input-group-append">
                  <button (click)="goToScheduler()" type="button" title="Open Workshop Booking">
                    <svg xmlns="http://www.w3.org/2000/svg" height="34px" viewBox="0 -960 960 960" width="24px" fill="#000000">
                      <path
                        d="M42-120v-112q0-33 17-62t47-44q51-26 115-44t141-18q77 0 141 18t115 44q30 15 47 44t17 62v112H42Zm80-80h480v-32q0-11-5.5-20T582-266q-36-18-92.5-36T362-320q-71 0-127.5 18T142-266q-9 5-14.5 14t-5.5 20v32Zm240-240q-66 0-113-47t-47-113h-10q-9 0-14.5-5.5T172-620q0-9 5.5-14.5T192-640h10q0-45 22-81t58-57v38q0 9 5.5 14.5T302-720q9 0 14.5-5.5T322-740v-54q9-3 19-4.5t21-1.5q11 0 21 1.5t19 4.5v54q0 9 5.5 14.5T422-720q9 0 14.5-5.5T442-740v-38q36 21 58 57t22 81h10q9 0 14.5 5.5T552-620q0 9-5.5 14.5T532-600h-10q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T442-600H282q0 33 23.5 56.5T362-520Zm300 160-6-30q-6-2-11.5-4.5T634-402l-28 10-20-36 22-20v-24l-22-20 20-36 28 10q4-4 10-7t12-5l6-30h40l6 30q6 2 12 5t10 7l28-10 20 36-22 20v24l22 20-20 36-28-10q-5 5-10.5 7.5T708-390l-6 30h-40Zm20-70q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm72-130-8-42q-9-3-16.5-7.5T716-620l-42 14-28-48 34-30q-2-5-2-8v-16q0-3 2-8l-34-30 28-48 42 14q6-6 13.5-10.5T746-798l8-42h56l8 42q9 3 16.5 7.5T848-780l42-14 28 48-34 30q2 5 2 8v16q0 3-2 8l34 30-28 48-42-14q-6 6-13.5 10.5T818-602l-8 42h-56Zm28-90q21 0 35.5-14.5T832-700q0-21-14.5-35.5T782-750q-21 0-35.5 14.5T732-700q0 21 14.5 35.5T782-650ZM362-200Z"
                      />
                    </svg>
                  </button>
                </div>
                <input
                  class="form-control"
                  name="d2"
                  ngbDatepicker
                  #d2="ngbDatepicker"
                  [dayTemplate]="customDay"
                  [footerTemplate]="footerTemplate"
                  formControlName="requestDate"
                  [placement]="'bottom-right'"
                  [class.is-invalid]="form.get('requestDate').errors?.invalid"
                  container="body"
                  [readonly]="orderHeader?.readOnlyYN === 'Y' || checkOrderHeaderMessages()"
                  autoClose="false"
                  (dateSelect)="showDetails($event)"
                  (navigate)="navigateCalendar($event)"
                  (keydown)="checkAllowEditable($event)"
                  [markDisabled]="isDisabled"
                />
                <div *ngIf="!checkOrderHeaderMessages() || !orderHeader?.workshopBookingTF === true" class="input-group-append">
                  <button
                    *ngIf="orderHeader?.readOnlyYN === 'N'"
                    class="btn btn-secondary calendar text-white btn-picker"
                    (click)="d2.open()"
                    (click)="streamOpened($event)"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2 mx-0">
          <div *ngIf="orderHeader?.readOnlyYN === 'N'" class="col-3 d-flex align-items-center">
            <label class="col-5">HOLD CODES</label>
            <div class="col-7">
              <ng-select
                formControlName="holdCodes"
                [appendTo]="'body'"
                [searchable]="true"
                [readonly]="orderHeader?.readOnlyYN === 'Y'"
                placeholder="Select"
              >
                <ng-option *ngFor="let code of allHoldCodeList" [value]="code"> ({{ code.code }}) {{ code.description }} </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="col-3 flex-wrap d-flex align-items-left">
            <ul *ngFor="let code of selectedHoldCodeList" [ngStyle]="{ display: 'inline-block' }" class="my-0">
              <li [ngStyle]="{ float: 'left', color: code.readOnlyYN === 'Y' ? 'red' : 'black' }">
                ({{ code.holdCode || code.code }}) {{ code.description }}
                <mat-icon
                  *ngIf="orderHeader?.readOnlyYN !== 'Y' && code.readOnlyYN !== 'Y'"
                  [ngStyle]="{ 'vertical-align': 'bottom' }"
                  (click)="removeHoldCode(code)"
                  title="Remove hold code"
                >
                  delete
                </mat-icon>
              </li>
            </ul>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5 d-flex align-items-center">
              VEHICLE
              <span class="px-1"></span>
              <mat-icon (click)="openEditVehicleModal()" *ngIf="isVehicleDataReady && orderHeader?.readOnlyYN === 'N'" title="Edit vehicle">
                edit
              </mat-icon>
              <mat-icon
                *ngIf="orderHeader?.readOnlyYN === 'N' && form.controls.vehicle.value?.trim().length > 0"
                (click)="clearVehicle()"
                class="my-auto"
                title="Remove vehicle"
                >clear</mat-icon
              >
            </label>
            <div class="col-7 pr-2">
              <input class="form-control" formControlName="vehicle" [readonly]="orderHeader?.readOnlyYN === 'Y'" />
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <div class="col-11">
              <input class="form-control" formControlName="vehicleColour" [readonly]="orderHeader?.readOnlyYN === 'Y'" />
            </div>
            <div
              *ngIf="
                form.controls.vehicleColour?.value &&
                form.controls.vehicleColour?.value.trim() !== '' &&
                form.controls.vehicleColour.value !== 'TBA TO BE ADVISED' &&
                orderHeader?.readOnlyYN !== 'Y'
              "
              class="col-1 px-1"
            >
              <mat-icon (click)="colourAll()" title="Use vehicle colour for all paintable lines"> brush </mat-icon>
            </div>
          </div>
        </div>

        <div class="d-flex pt-2">
          <div
            class="flex-grow-1 w-50"
            *ngIf="
              (!brandDefaults?.showMarketingOptInTF &&
                (orderType === 'SQ' || orderType === 'SO' || orderType === 'S6') &&
                customerType === 'RETAIL' &&
                marketingYN === '' &&
                !isProgrammeUser &&
                !isGenericQuotesOnlyTF) ||
              (orderHeader?.quickSaleYN === 'Y' && customerType === 'RETAIL' && !isProgrammeUser && !isGenericQuotesOnlyTF)
            "
          >
            <label class="text-danger custom">SIGN CUSTOMER UP TO ARB'S EMAIL SUBSCRIPTION ?</label>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" formControlName="marketingOptInYNFromOrder" value="Y" />
              <label class="form-check-label" for="radio1"> YES</label>
            </div>
         
            <div *ngIf="orderHeader?.quickSaleYN !== 'Y'" class="form-check form-check-inline">
              <input class="form-check-input" type="radio" formControlName="marketingOptInYNFromOrder" value="N" />
              <label class="form-check-label" for="radio1"> NO </label>
            </div>
          </div>
          <div class="flex-grow-1" style="text-align: right">
            <label
              *ngFor="let message of headerMessages"
              [ngClass]="message.msgType === 'ERROR' ? 'text-danger' : message.msgType === 'WARN' ? 'text-warning' : 'text-success'"
              class="mx-2 text-uppercase"
            >
              <span *ngIf="message?.linkText" style="border-bottom: 2px solid rgb(86, 153, 241)" (click)="showLinkedText(message.linkText)"
                >*{{ message.message }}</span
              >
              <span *ngIf="!message?.linkText">*{{ message.message }}</span>
            </label>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="INFORMATION">
      <div class="py-4 information">
        <div class="row row-gap mx-0">
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">SOLD TO</label>
            <div class="col-7 nowrap">
              <a class="form-control overflow-hidden" (click)="editCustomer()">
                <u>{{ form.controls.customerName.value }}</u>
              </a>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">TERMS</label>
            <div class="col-7">
              <div class="form-control">{{ orderHeader.paymentTermDesc || '' }}</div>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">CHANNEL</label>
            <div class="col-7">
              <div class="form-control"  >{{ orderHeader.priceChannelDesc || '' }}</div>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">ORDER DATE</label>
            <div class="col-4">
              <div class="form-control">
                {{ orderHeader.orderCreateDateString }}
              </div>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5"
              >SHIP TO
              <span *ngIf="orderHeader?.orderNumber.startsWith('T')" class="my-auto pl-2">
                <mat-icon
                  *ngIf="
                    customerShipToList &&
                    customerShipToList?.length > 0 &&
                    ((!isExternalUser && !isProgrammeUser) ||
                      ((isExternalUser || isProgrammeUser) && form.controls.orderType.value === 'SQ' && !isGenericQuotesOnlyTF))
                  "
                  (click)="selectShipToCustomer()"
                  title="Change Customer"
                  >edit</mat-icon
                >
              </span>
            </label>
            <div class="col-7">
              <a class="form-control" (click)="editShipToCustomer()">
                <u>{{ orderHeader.shipToName }}</u>
              </a>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5"
              >SALESPERSON
              <mat-icon *ngIf="orderHeader?.readOnlyYN !== 'Y'" (click)="changeSalesPerson()" style="padding-top: 4px">supervisor_account</mat-icon>
            </label>
            <div class="col-7">
              <div class="form-control" >{{ orderHeader.salespersonName }}</div>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">ORIGINAL ORDER</label>
            <div class="col-7">
              <a class="form-control" (click)="editOriginalOrder()">
                <u>{{ orderHeader.originalOrder }}</u>
              </a>
            </div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <label class="col-5">CURRENCY</label>
            <div class="col-4">
              <input class="form-control" formControlName="currencyCode" [readonly]="orderHeader?.readOnlyYN === 'Y'" />
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</form>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">
      {{
        isGarage
          ? 'SELECT VEHICLE'
          : isAddingCustomer
            ? 'NEW CUSTOMER'
            : isSelectingCustomer
              ? 'SELECT CUSTOMER'
              : isEditingCustomer || isEditingShiptoCustomer
                ? 'EDIT CUSTOMER'
                : isSelectingShipToCustomer
                  ? 'SELECT SHIP TO CUSTOMER'
                  : 'ORDER NOTE'
      }}
    </h3>
  </div>
  <div class="modal-body">
    <div
      *ngIf="!isGarage && !isAddingCustomer && !isSelectingCustomer && !isEditingCustomer && !isEditingShiptoCustomer && !isSelectingShipToCustomer"
    >
      <app-order-header-notes
        [preloadAttachments]="allAttachments"
        [orderNumber]="orderHeader.orderNumber"
        [orderType]="orderHeader.orderType"
        [orderCompany]="orderHeader.orderCompany"
        [isReadOnly]="isReadOnlyOrderNote"
        (reloadedAttachments)="loadAllAttachments.emit()"
        (closeActiveModal)="handleCloseModal($event)"
      ></app-order-header-notes>
    </div>
    <div *ngIf="isGarage">
      <app-vehicles-selection
        *ngIf="isGenericVehicleYN && !isAddVehicleForCustomer && !orderHeader?.customerVehicleID; else selectVehicleTemplate"
        (cancelSelect)="d('Cross click')"
        (submitCar)="onSelectVehicle($event)"
      ></app-vehicles-selection>

      <ng-template #selectVehicleTemplate>
        <!-- when generic vehicle with vehicleID then allow them to edit generice vehicle details -->
        <app-customers-vehicles-details
          *ngIf="isGenericVehicleYN && orderHeader?.customerVehicleID"
          [isGenericVehicleYN]="isGenericVehicleYN"
          [generiVehicleDetailFromOrder]="generiVehicleDetailFromOrder"
          [currentCustomer]="orderHeader.customerNumber"
          [currentCustomerVehicle]="orderHeader?.customerVehicleID"
          (vehicleEditted)="vehicleEditted($event)"
          (cancelEdit)="cancel()"
        ></app-customers-vehicles-details>
        <!-- when generic vehicle without vehicleID and is AddVehicleForCustomer -->
        <app-customers-vehicles
          *ngIf="!isGenericVehicleYN || (isGenericVehicleYN && isAddVehicleForCustomer)"
          [customerNumber]="orderHeader.customerNumber"
          [currentCustomerVehicleId]="orderHeader.customerVehicleID"
          [preselectedVehicle]="tempVehicle"
          [isAddVehicleForCustomer]="isAddVehicleForCustomer"
          [isAddVehicleForGenericCustomer]="isAddVehicleForGenericCustomer"
          (closeActiveModal)="handleCloseModal($event); isAddVehicleForCustomer = false"
          (selectVehicleEvent)="selectCustomerVehicle($event)"
          (savedVehicleForGenericCustomer)="savedVehicleForGenericCustomer($event)"
        ></app-customers-vehicles>
      </ng-template>
    </div>
    <div *ngIf="isAddingCustomer">
      <app-customers-details-new
        [isForNewOrder]="true"
        [marketingOptInYNFromOrder]="marketingYNValue"
        (newCustomer)="fetchCustomerDetails($event)"
      ></app-customers-details-new>
    </div>
    <div *ngIf="isEditingCustomer && !isSelectingShipToCustomer">
      <app-customers-details
        [isForNewOrder]="true"
        [preSelectedCustomer]="selectedCustomer"
        [marketingOptInYNFromOrder]="marketingYNValue"
        (updatedCustomer)="fetchCustomerDetails($event)"
      ></app-customers-details>
    </div>
    <div *ngIf="isEditingShiptoCustomer">
      <app-customers-details
        [isForNewOrder]="true"
        [preSelectedCustomer]="shiptoCustomer"
        [marketingOptInYNFromOrder]="marketingYNValue"
        (updatedCustomer)="fetchCustomerDetails($event)"
        [allCombinedBranchesList]="allCombinedBranchesList"
        [soldToCustomer]="selectedCustomerDetails$ | async"
        [allCombinedBranchesList]="allCombinedBranchesList"
      ></app-customers-details>
    </div>
    <div *ngIf="isSelectingCustomer && !isAddingCustomer">
      <pos-app-lib-customer-search (selectNewCustomer)="handleSelectCustomer($event)" [forOrderHeader]="true"></pos-app-lib-customer-search>
      <button class="btn btn-cancel mt-3 float-right" (click)="handleCloseModal(true)">CLOSE</button>
      <button class="btn btn-warning mt-3 float-right" (click)="addNewCustomer()" *ngIf="isSelectingCustomer">CREATE NEW CUSTOMER</button>
    </div>
    <div *ngIf="isSelectingShipToCustomer && !isEditingShiptoCustomer">
      <div class="row">
        <form [formGroup]="shipToCustomerTypeForm" class="col-3 col-lg-4">
          <ng-select formControlName="shipToCustomerSelection" [clearable]="false">
            <ng-option [value]="0"> <label>Specified Ship To Customer</label> </ng-option>
            <ng-option [value]="1"> <label>One-Off Ship To Customer</label> </ng-option>
          </ng-select>
        </form>
        <div *ngIf="shipToCustomerTypeForm.get('shipToCustomerSelection').value === 0" class="col-3 col-lg-8">
          <div class="col-7">
            <ng-select
              [ngModel]="orderHeader.shipToNumber"
              (ngModelChange)="onShipToNumberChange($event)"
              [clearable]="false"
              class="custom"
              [readonly]="orderHeader?.readOnlyYN === 'Y'"
            >
              <ng-option *ngFor="let customerShipTo of customerShipToList" [value]="customerShipTo.shipToNumber">
                {{ customerShipTo.shipToName }} ({{ customerShipTo.shipToNumber }})
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div *ngIf="shipToCustomerTypeForm.get('shipToCustomerSelection').value === 1" class="col-3 col-lg-8">
          <pos-app-lib-customer-ship-to-search #shipToSearch (selectNewShipToCustomer)="selectOneOffCustomer($event)" removeCustomerAfterLoad="false">
          </pos-app-lib-customer-ship-to-search>
        </div>
      </div>

      <div class="col-12 d-flex justify-content-end">
        <button class="btn mt-3 float-right" (click)="updateShipToCustomer()">SAVE</button>
        <button class="btn btn-cancel mt-3 float-right" (click)="handleCloseModal(true)">CLOSE</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #releaseOrderHoldModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">RELEASE ORDER HOLD</h3>
  </div>
  <div class="modal-body">
    <div class="row pb-2">
      <div class="col-4 my-auto">
        <label class="my-auto">PASSWORD</label>
      </div>
      <div class="col-8">
        <input type="password" class="form-control" [(ngModel)]="holdCodePassword" (keyup.enter)="onRemoveHoldCode()" />
      </div>
    </div>
    <div class="row pb-2">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-cancel mr-3" (click)="closeHoldCodeModal()">CANCEL</button>
        <button class="btn text-white" (click)="onRemoveHoldCode()" [disabled]="!holdCodePassword || (isBusy$ | async)">
          ENTER
          <pos-app-spinner2 *ngIf="isBusy$ | async"></pos-app-spinner2>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <div
    id="calanderDayParent{{ date.day }}{{ date.month }}{{ date.year }}"
    *ngIf="date.month === currentMonth"
    style="width: 50px; margin-left: -10px"
  >
    <div
      class="customCss"
      [class.hidden]="date.month !== currentMonth"
      id="calanderDayChild00{{ date.day }}{{ date.month }}{{ date.year }}"
      data-toggle="tooltip"
      data-placement="top"
      title=""
    >
      {{ date.day }}
    </div>
    <div id="calanderValue{{ date.day }}{{ date.month }}{{ date.year }}" style="justify-content: center; font-size: x-small"></div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <hr class="my-0" />
  <!-- show selectedFitDays as dropdown -->
  <div class="d-flex justify-content-end align-items-center p-2">
    <div *ngIf="selectedFitDays.length" class="p-2" style="width: 250px; min-width: 180px">
      <ng-select
        [items]="selectedFitDays"
        bindLabel="date"
        bindValue="date"
        [placeholder]="'Show all selected Date'"
        (change)="goToSelectedDate($event)"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item }}
        </ng-template>
      </ng-select>
    </div>

    <div class="p-2 ml-auto d-flex justify-content-end">
      <button class="btn btn-primary btn-sm" (click)="updateHeaderDate()">DONE</button>
    </div>
  </div>
</ng-template>

<ng-template #changeSalespersonContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">CHANGE SALESPERSON ON ORDER</h3>
  </div>
  <div>
    <div class="modal-body">
      <pos-app-lib-customer-order-salesperson-selector
        [currentSalesPerson]="getSalesPersonNameOnly(orderHeader?.salesperson)"
        [orderNumber]="orderHeader?.orderNumber"
        [orderType]="orderHeader?.orderType"
        [JDEOrderType]="orderHeader?.jdeOrderType"
        [JDECompany]="orderHeader?.jdeCompany"
        [salesPeopleList]="salesPeopleList"
        (reloadData)="reloadData()"
        (closeActiveModal)="closeModal()"
      ></pos-app-lib-customer-order-salesperson-selector>
    </div>
  </div>
</ng-template>
